module.exports = __webpack_public_path__ + "media/c.62d72b57.mp3";